export default __webpack_public_path__ + "static/media/attila_security.129e8416.jpg";